export default __webpack_public_path__ + "static/international-metric-desktop-8fa9f91ed81579732fd4e22752d1df35.svg";